import Modal from "modal/Modal";
import $ from "jquery";

class ConfirmModal extends Modal {
    constructor(message, title = undefined, settings = {}) {
        super($.extend({}, ConfirmModal.DEFAULT_SETTINGS, settings));
        if ('undefined' === typeof title) title = 'Are you sure?';
        this.setContent(
            eotwJSXFactory('div', null, [
                eotwJSXFactory('h2', null, [title]),
                eotwJSXFactory('span', {class: "admin-modal--confirm__text"}, [message]),
                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal"}, ["Yes"]).on("click", () => {
                        this.emit("confirm");
                        if (this.settings.showLoading) {
                            this.$content.find(".admin-btn--confirm").addClass("admin-btn--loading");
                        } else {
                            this.destroy();
                        }
                    }),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal"}, ["Cancel"]).on("click", () => {
                        this.emit("cancel");
                        this.destroy();
                    })
                ])
            ])
        );
    }

    static confirm(message, title = undefined, settings = {}) {
        return new Promise((resolve, reject) => {
            let modal = new ConfirmModal(message, title, settings);

            modal.on("confirm", resolve.bind(undefined, () => modal.destroy())).on("cancel", reject);
            modal.show();
        });
    }
}

ConfirmModal.DEFAULT_SETTINGS = {
    "class": "modal--confirm",
    "closeButton": false,
    "backgroundClose": false,
    "escClose": false,
    showLoading: false
};

export default ConfirmModal;
